<template>
  <div class="forgot-password">
    <div class="landing-page-wrapper">
      <div class="landing-page-content">
        <div class="forgot-password custom-left-align">
          <h1 class="page-title">
            Your invitation is either expired or was already used
          </h1>
          <p class="page-description">
            The invitation link you used is not working. This may happen because:
          </p>
          <ul>
            <li>
              Your invitation was sent more than 30 days ago or your invitation was revoked. In this case, please ask the person who invited you to do it again.
            </li>
            <li>
              You may have already activated your account.If so, please check your invitation email for the temporary
              credentials we sent you and try to login using the form below. Otherwise, please contact support.team@clearassured.co.uk
            </li>
          </ul>
          <div class="landing-page-login-wrapper">
            <div class="landing-page-login-group"
                 :class="[{ 'active': topLoginForm.email !== '' || topLoginForm.emailFocus, 'has-error': topLoginForm.isError }]">
              <label for="landing-page-login-email">Email</label>
              <input id="landing-page-login-email"
                     type="email"
                     @keyup.enter="authenticate('top')"
                     @focus="topLoginForm.emailFocus = true"
                     @blur="topLoginForm.emailFocus = false"
                     v-model="topLoginForm.email" />
            </div>
            <div class="landing-page-login-group"
                 :class="[{ 'active': topLoginForm.password !== '' || topLoginForm.passwordFocus, 'has-error': topLoginForm.isError }]">
              <label for="landing-page-login-password">Password</label>
              <span class="landing-page-login-password-show"
                    @click.prevent="showPassword('top')"></span>
              <input id="landing-page-login-password"
                     @keyup.enter="authenticate('top')"
                     :type="topLoginForm.passwordType"
                     @focus="topLoginForm.passwordFocus = true"
                     @blur="topLoginForm.passwordFocus = false"
                     v-model="topLoginForm.password" />
            </div>
            <div class="login-form-error" v-if="topLoginForm.isError">
              {{ topLoginForm.loginErrorMessage }}
            </div>
            <div class="landing-page-login-actions custom-left-align-actions">
              <router-link :to="{ name: 'forgot-password' }" class="reset-password">Forgot password?</router-link>
              <a href="#" class="login background-1-100"
                 :class="[{ 'active-logging': topLoginForm.loginInProgress }]"
                 @click.prevent="authenticate('top')">Login</a>
            </div>
          </div>
          <div class="landing-page-login-info">
            Having trouble accessing your account? <br/>
            <router-link :to="{ name: 'contact' }">Get in touch</router-link> and tell us about your problem, we’ll do our best to help you.
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import api from '@/api'

  export default {
    name: 'expired-account-token',
    data () {
      return {
        resetInProgress: false,
        formStatus: {
          shown: false,
          success: false,
          title: '',
          body: ''
        },
        emailFocus: false,
        formInfo: {
          email: ''
        },
        topLoginForm: {
          email: '',
          password: '',
          grantType: 'password',
          clientId: '2_659vq9a3czggcws88wcws8s4kc8gc8gcss4wog4cwcsk08ggkg',
          clientSecret: '5ncmjzrt9ps8808cskk8ogwwgwkgks8ggc0kskg0cw48s08ks4',
          emailFocus: false,
          passwordFocus: false,
          loginInProgress: false,
          isError: false,
          loginErrorMessage: '',
          passwordType: 'password'
        },
        ppp: 5,
        footerEdit: false
      }
    },
    computed: {
      ...mapGetters([
        'getIsLoggedIn',
        'getUserRole',
        'selectedHightCont',
        'getSelectedFontSize'
      ])
    },
    methods: {
      ...mapActions([
        'redirect',
        'getRoles',
        'setFontSizeActive',
        'setColorPaletteActive'
      ]),
      authenticate (form) {
        this.topLoginForm.loginInProgress = true
        let auth = {
          grant_type: this.topLoginForm.grantType,
          client_id: this.topLoginForm.clientId,
          client_secret: this.topLoginForm.clientSecret,
          username: this.topLoginForm.email,
          password: this.topLoginForm.password
        }
        this.$http.post(api.URLS.login, auth).then((res) => {
          let headers = {headers: {'Authorization': `Bearer ${res.body.access_token}`}}
          document.cookie = 'Recite.Persist=; Max-Age=-99999999;'
          localStorage.setItem('token', res.body.access_token)
          this.$http.put(api.URLS.profile, {}, headers)
            .then((res) => {
              let userData = {
                'id': res.body.id ? res.body.id : '',
                'firstName': res.body.first_name ? res.body.first_name : '',
                'lastName': res.body.last_name ? res.body.last_name : '',
                'userRole': res.body.role.slug,
                'company': res.body.company ? res.body.company.id : null
              }
              if (['ca', 'gm'].indexOf(res.body.role.slug) > -1 && res.body.consent_status === 0) {
                localStorage.setItem('consentHead', 'true')
              }
              localStorage.setItem('consentSeen', res.body.consent_seen)
              localStorage.setItem('userData', JSON.stringify(userData))
              localStorage.setItem('cookieFixed', true)
              localStorage.setItem('userIndustry', (res.body.company && res.body.company.industry) ? res.body.company.industry.id : 1)
              document.getElementById('app').setAttribute('data-industry', (res.body.company && res.body.company.industry) ? res.body.company.industry.id : 1)
              if (res.body.company) {
                localStorage.setItem('userCompanyName', res.body.company.name)
              }
              if (res.body.company && res.body.company.industry) {
                localStorage.setItem('userIndustryName', res.body.company.industry.name)
              }
              this.$store.commit('authLoginSuccess')
              this.$store.commit('authLoginSetUsername', userData.firstName)
              this.redirect()
            })
            .catch((err) => {
              if (err.status === 401) {
                localStorage.removeItem('token')
                localStorage.removeItem('userData')
                localStorage.removeItem('consentSeen')
                localStorage.removeItem('consentHead')
                localStorage.removeItem('userIndustryName')
                localStorage.removeItem('userCompanyName')
                this.topLoginForm.isError = true
                this.topLoginForm.loginInProgress = false
                this.topLoginForm.loginErrorMessage = 'Your account is inactive. Please contact support.'
              }
            })
        }).catch(() => {
          this.topLoginForm.isError = true
          this.topLoginForm.loginInProgress = false
          this.topLoginForm.loginErrorMessage = 'Invalid credentials'
        })
      }
    },
    created () {
      document.title = 'Clear Assured – account token expired'
    }
  }
</script>

<style src="@/assets/scss/main/landing-page.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// ExpiredAccountToken.vue?e6d01ef2